import LabeledHOC from '@platform/react/hoc/list/labeled'
import CellHOC from '@platform/react/hoc/list/cell'
import { ListItemCellPersonNameOrCount, styles } from 'ui/Element/List/Item/Cell/Person/NameOrCount'

export default CellHOC(
  LabeledHOC(
    props => props.labels.plural, ListItemCellPersonNameOrCount,
  ), styles,
)
